module.exports = __webpack_public_path__ + "static/assets/f345347785c3eeec8edeeb6207dcd63b.png";